import http from "../common/api";
import { ApiSettings } from "application";
import { getMyDocumentsFromServer } from "./adapter";

const getMyDocuments = async (user) => {
  const { email } = user;

  const response = await http.post(
    ApiSettings.getMyDocuments,
    {
      bool: {
        must_not: [
          {
            term: {
              deleted: true,
            },
          },
        ],
        should: [
          {
            term: {
              creator: email,
            },
          },
          {
            nested: {
              path: "owner",
              query: {
                term: {
                  "owner.owner_email": email,
                },
              },
            },
          },
        ],
      },
    },
    { target: "alf" }
  );

  return getMyDocumentsFromServer(response);
};

export default getMyDocuments;
